import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AccordionComponent } from '../../../../shared/components/accordion/accordion.component';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { CustomEditorComponent } from '../../../../shared/components/custom-editor/custom-editor.component';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-blog-summary',
  standalone: true,
  imports: [
    AccordionComponent,
    CustomEditorComponent,
    ButtonComponent,
    ButtonLoaderComponent,
    SharedModule,
  ],
  templateUrl: './blog-summary.component.html',
  styleUrl: './blog-summary.component.scss',
})
export class BlogSummaryComponent {
  @Input() summaryData: any[] = [];
  @Output() addBlogSummary: EventEmitter<any> = new EventEmitter();
  @Output() updateBlogSummary: EventEmitter<any> = new EventEmitter();
  @Output() deleteSummary: EventEmitter<any> = new EventEmitter();
  summaryForm = this.fb.group({
    id: [''],
    title: ['', [Validators.required]],
    content: ['', [Validators.required]],
  });
  maxHeight = '0px';
  activeIndex = -1;
  menuOpenIndex = -1;
  editIndex = -1;
  constructor(
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document: Document
  ) {}

  toggleAccordian(index: number) {
    if (this.activeIndex === index) {
      this.activeIndex = -1;
      this.maxHeight = `0px`;
    } else {
      const elm = this.document.getElementById(`summaryPanel${index}`);
      this.maxHeight = `${elm?.scrollHeight}px`;
      this.activeIndex = index;
    }
  }

  add() {
    if (this.summaryForm.invalid) {
      this.summaryForm.markAllAsTouched();
      return;
    }
    if (this.editIndex > -1) {
      this.updateBlogSummary.emit({
        index: this.editIndex,
        summary: this.summaryForm.value,
      });
      this.editIndex = -1;
    } else {
      this.addBlogSummary.emit(this.summaryForm.value);
    }

    this.summaryForm.reset();
  }

  closeAllMenu(index: number) {
    if (index === this.menuOpenIndex) {
      this.menuOpenIndex = -1;
    }
  }

  openMenu(index: number) {
    this.menuOpenIndex = index;
  }

  clearForm() {
    this.summaryForm.reset();
  }

  onEdit(index: number) {
    this.editIndex = index;
    this.summaryForm.setValue({
      id: this.summaryData[index]?.id ?? '',
      title: this.summaryData[index].title,
      content: this.summaryData[index].content,
    });
  }
  onDelete(index: number) {
    this.deleteSummary.emit(index);
  }
}
